import React from 'react';
import {
  Row,
  Col,
  Form,
  FormInput,
  FormSelect,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Card,
  Button,
  Container
} from "shards-react";
import { Redirect } from 'react-router';
import firebase from '../firebase';
import PageTitle from "../common/PageTitle";

// Main app
class Login extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {email:null,password:null,loading:false,logged_in:false};
    this.login = this.login.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

   handleSubmit(event) {
    this.login();
    event.preventDefault();
  }

  componentDidMount(){
    var that = this;
    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            // User is signed in.
            console.log(user);
            that.setState({logged_in:true});
             
        } else {
            // No user is signed in.
            console.log("No user");
            that.setState({logged_in:false});
            
        }
    })
  }
    


  login=()=>{
    var that =this;

  if(this.state.email===null || this.state.password===null){
    alert("Please enter details");
    return;
  }
  //Logs out as soon as the current tab is closed
  that.setState({loading:true});
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .then(function() {
     firebase.auth().signInWithEmailAndPassword(that.state.email, that.state.password).then(function(){
          //logged in succesfully
          that.setState({loading:false});
     }).catch(function(error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message;
                            alert(errorMessage);
                            that.setState({loading:false});
                      // ...
      });
              
      }).catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                alert(errorMessage);
                that.setState({loading:false});
      });
    }


  render() {

    if(!this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/" />;
    }

    return (


      <Container fluid className="main-content-container px-4">

             {/* Page Header */}
              <Row noGutters className="page-header py-4">
                        <PageTitle sm="6" title="Login" subtitle="" className="text-sm-left" />
              </Row>

              
            <Form_20 style={{marginTop:'40%'}} 
                handleSubmit={this.handleSubmit} 
                write_email={(evt)=>{this.setState({email:evt.target.value})}} 
                write_password={(evt)=>{this.setState({password:evt.target.value})}}
                loading={this.state.loading}/>
                    
       </Container>

   

      )
  }
}





class Form_20 extends React.Component{
  render(){
    return( 
    <div>
    <Col md="3" sm="0"></Col>
    <Col sm="12" md="6" style={{backgroundColor:'white',marginLeft: '20%'}}>
    
    <br />
    <br />
    <br />
     <h4 className=" d-block mb-2" style={{color:'blue',textAlign:'center',marginTop: '0%'}} >Little Start Pre School</h4>
    <Form style={{marginTop:'10%'}} onSubmit={this.props.handleSubmit}>
      <FormGroup>
        <InputGroup className="mb-3">
          <InputGroupAddon type="prepend">
            <InputGroupText>@</InputGroupText>
          </InputGroupAddon>
          <FormInput placeholder="Username" onChange={this.props.write_email}/>
        </InputGroup>
      </FormGroup>
      <FormGroup>
        <FormInput
          type="password"
          placeholder="Password"
          onChange={this.props.write_password}
        />
      </FormGroup>
      {
        !this.props.loading && 
        <Button theme="primary" size="sm">Login</Button>
      }
      {
        this.props.loading &&
        <strong>Loading...</strong>
      } 
   </Form>
  


  </Col>
  </div>
)
  }
}


export default Login;